module.exports = __webpack_public_path__ + "static/media/middle_manager_small.86626b27.jpg";